import Curiosity from './curiosity'
export default Curiosity;